module.exports = __webpack_public_path__ + "media/images/people/girl-3-8a842c9f2bb3ebea329e41e7204e1f5b.webp";